module.exports = __webpack_public_path__ + "5a6431c0854a876d9f981f94fb732ddb.pdf";